/**
 * Firebase-Anbindung des Clients.
 *
 * Der Client liest Firestore direkt — die Rules beschraenken das auf die zwei
 * Team-Adressen. Geschrieben wird nur ueber Callables, weil dort die Schluessel
 * fuer MOCO und die Bank liegen.
 */

import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, connectAuthEmulator, getAuth, signInWithPopup, signOut } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";

/** Muss zur Region der Functions passen, sonst laufen Callables ins Leere. */
const REGION = "europe-west3";

const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});

export const auth = getAuth(app);
export const dbc = getFirestore(app);
export const functions = getFunctions(app, REGION);

if (import.meta.env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
  connectFirestoreEmulator(dbc, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export function signIn(): Promise<unknown> {
  const provider = new GoogleAuthProvider();
  // Ohne diesen Hinweis waehlt Google stillschweigend das zuletzt genutzte
  // Konto — bei zwei Konten im Browser landet man dann im falschen.
  provider.setCustomParameters({ prompt: "select_account" });
  return signInWithPopup(auth, provider);
}

export function signOutNow(): Promise<void> {
  return signOut(auth);
}

export const callTriggerSync = httpsCallable(functions, "triggerSync");
export const callDecideMatch = httpsCallable<{ matchId: string; accept: boolean }, { ok: boolean }>(functions, "decideMatch");
export const callDecideAssignment = httpsCallable<
  { plannedItemId: string; bankTransactionIds: string[]; accept: boolean },
  { ok: boolean; status: string }
>(functions, "decideAssignment");
export const callUndoDecision = httpsCallable<{ plannedItemId: string }, { ok: boolean; zurueckgenommen: number }>(
  functions,
  "undoDecision",
);
export const callManualMatch = httpsCallable<
  { plannedItemId: string; bankTransactionId: string },
  { ok: boolean; amountCents: number }
>(functions, "createManualMatch");
export const callWriteBack = httpsCallable<{ matchId: string }, { ok: boolean }>(functions, "writeBackToMoco");
